export const PATH_NAME = {
    LOGIN: "/login",
    PAGE_404: "/404",
    NOT_FOUND: "/notfound",
    HOME: "/", // Người mua
    COLLECTIONS: "/collections", // Người bán
    PROJECT: "/project",
    ABOUT_OUR: "/about", // Người bán
    CONTACT: "/contact", // Người bán
    GUARANTEE: "/guarantee",
    SECURITY: "/security",
    PAYMENT: "/payment",
    TRANSPORT: "/transport",
    CATALOGUE: "/catalogue",

    KE_DRIVER_IN: "/products/ke-drive-in",
    KE_SELECTIVE: "/products/ke-selective",
    KE_DOUBLE_DEEP: "/products/ke-double-deep",
    KE_NARROW_AISLE: "/products/ke-narrow-aisle",
    KE_PALLET_DI_DONG: "/products/ke-pallet-di-dong",
    KE_CON_LAN_PALLET_FLOW_RACK: "/products/ke-con-lan-pallet-flow-rack",
    KE_PUSH_BACK: "/products/ke-push-back",
    KE_TAY_DO: "/products/ke-tay-do",
    KE_DE_KHUON_MOULD_RACK: "/products/ke-de-khuon-mould-rack",
    KE_TRUNG_TAI: "/products/ke-trung-tai",
    KE_CON_LAN_TRUNG_TAI: "/products/ke-con-lan-trung-tai",
    KE_V_HOA: "/products/ke-v-hoa",
    KE_V_LO: "/products/ke-v-lo",
    KE_SAN_MEZZANINE: "/products/ke-san-mezzanine",
    KE_XEP_CHONG: "/products/ke-xep-chong",
    KE_DE_HANG_BAN_TU_DONG: "/products/ke-de-hang-ban-tu-dong",
    KE_SIEU_THI: "/products/ke-sieu-thi",
    MANG_CAP: "/products/mang-cap",
    GIA_CONG_LAZE: "/products/gia-cong-laser",
    BAN_THAO_TAC: "/products/ban-thao-tac",
    XE_DAY: "/products/xe-day",
    BANG_TAI: "/products/bang-tai",
    PALET_XEP_CHONG: "/products/palet-xep-chong",

    PROJECT_YENPHONG_BACNINH: "/project/gia-ke-kho-cong-nghiep-du-an-tai-yen-phong-bac-ninh",
    PROJECT_SIEU_THI_LONG_BIEN: "/project/ke-sieu-thi-long-bien-khach-hang-lon-tai-ngoc-thuy",
    PROJECT_LACSON_HOABINH: "/project/ke-sat-v-lo-hoa-binh",
    PROJECT_TIENDU_BACNINH: "/project/gia-ke-kho-hang-du-an-tai-tien-du-bac-ninh",
    PROJECT_NINHBINH: "/project/ke-sat-trung-tai-3-tang-tai-ninh-binh",
    PROJECT_VIN_05_02_2020: "/project/sieu-du-an-ke-trung-tai-tai-tap-doan-vin-tai-trung-tam-du-lieu-vin",

    ADMIN: "/admin",
    ADMIN_CONTACT_PAGE: "/admin-contact-page",
}


export const LINK_CATALOGUE = "https://drive.google.com/file/d/1H-frDOuEx0pTjGlFFDiK5wl6eA26cz-4/view"

